/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * OccupancyBackendError Component
 * @returns {Element}
 * @constructor
 */
export function OccupancyBackendError() {
  return (
    <Box className="backend-error">
      <Typography>Fehler: Es ist keine Studio ID (Magicline API) gepflegt.</Typography>
    </Box>
  );
}
